import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const activityTypesAdapter = getAdapter({ idFieldName: 'value' });

const activityTypesSlice = createSlice({
  name: 'activityTypes',
  initialState: activityTypesAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setActivityTypes: (state, { payload: { activityTypes, source } }) => {
      activityTypesAdapter.setAll(state, activityTypes);
      state.source = source;
    },
  },
});

const selectors = activityTypesAdapter.getSelectors(({ activityTypes }) => activityTypes);

export const getActivityTypes = (state) => selectors.selectAll(state);

export const {
  setActivityTypes: setActivityTypes,
} = activityTypesSlice.actions;

export default activityTypesSlice.reducer;